import * as React from "react";
const SvgFiRrSkiingNordic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-skiing-nordic_svg__a)">
      <path
        fill="#062147"
        d="M23 19a1 1 0 0 0-1 1 2 2 0 0 1-1.758 1.975l2.736-12.766a.999.999 0 1 0-1.956-.418L20.549 11h-1.42a1 1 0 0 1-.855-.484l-1.261-2.094A5.03 5.03 0 0 0 12.729 6h-6.23a3.01 3.01 0 0 0-2.416 1.22l-.875 1.186a1 1 0 1 0 1.609 1.188l.876-1.187A1 1 0 0 1 6.5 8h2.962L7.7 12.274a3 3 0 0 0 1.175 3.675l3.658 2.308A1 1 0 0 1 13 19.1V22H7.126l1.108-3.436a1 1 0 1 0-1.9-.614L5.024 22h-2.8l1.817-8.8a1 1 0 0 0-1.96-.4l-2.06 10A1 1 0 0 0 1 24h19a4 4 0 0 0 4-4 1 1 0 0 0-1-1m-9.4-2.434-3.657-2.308a1 1 0 0 1-.392-1.224L11.625 8h1.1q.364.004.718.094l-1.864 4.525a1 1 0 1 0 1.849.762l1.7-4.134c.052.071.118.13.164.206l1.26 2.094A3.02 3.02 0 0 0 19.13 13h.99l-1.93 9H15v-2.9a2.98 2.98 0 0 0-1.4-2.534M12 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-skiing-nordic_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSkiingNordic;
